import { toQuery } from '@/utils/infrastructure';
import request from '@/utils/infrastructure/communication/request';

export async function queryList(params) {
  return request('/actionApiCallResponseMapping/paged', {
    params: toQuery(params),
  });
}

export async function queryEditItemApiCallResponse({ id, params }) {
  return request(`/actionApiCallResponseMapping/${id}`, {
    params: toQuery(params),
  });
}

export async function queryAddNewApiCallResponse(params) {
  return request.post(`/actionApiCallResponseMapping`, {
    data: params,
  });
}

export async function queryAddEditApiCallResponse(params) {
  return request.put('/actionApiCallResponseMapping', {
    data: params,
  });
}

export async function queryDeleteItem(id) {
  return request.delete(`/actionApiCallResponseMapping/${id}`, {});
}
